import * as React from 'react';
const SvgRoute = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 20 22" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.96 3.129a.75.75 0 01.369-1.263L10.096.821a.75.75 0 01.893.893L9.943 6.48a.75.75 0 01-1.262.37L4.959 3.128zm6.737 18.466a3.1 3.1 0 100-6.2 3.1 3.1 0 000 6.2zM5.407 6.403a1 1 0 00-1.414 0L1.69 8.705a4.246 4.246 0 000 6.004l.004.004a4.253 4.253 0 006.01-.004l6.006-6.005c.879-.879 2.303-.88 3.184-.001.878.876.879 2.297.003 3.175l-.002.002-1.77 1.77a1 1 0 001.414 1.414l1.77-1.77.004-.003a4.245 4.245 0 00-.007-6.004 4.253 4.253 0 00-6.01.003L6.29 13.295a2.253 2.253 0 01-3.185 0 2.246 2.246 0 010-3.176l2.302-2.302a1 1 0 000-1.414z"
            fill="currentColor"
        />
    </svg>
);
export default SvgRoute;
